<script>
  import { ignore } from '../../../Common/tools';
  import SingleWallSettings from './SingleWallSettings.svelte';

  export let wall,
    onChange = ignore,
    refreshUI = ignore,
    showGroupStyleSettings;
</script>

<div class="popup-widget-wrapper">
  <h4 class="col20 f-left mt-15 mb-25 t-center h4-bigger">{wall.groupSettings.name}</h4>
  <SingleWallSettings {wall} {onChange} {refreshUI} {showGroupStyleSettings} />
</div>
